import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/25p6pRU7PQm2zBwic36PeP/Bad_1.webp',
  title: '50 Badminton Warm-Up & Energizer Games',
  description: 'Fast, lively starts for every class',
  price: '$19'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/uL1WFr1BpK6ET6mNkrv4GE/Bad_2.webp',
  title: 'Badminton Rules & Umpire Signals Poster Pack',
  description: 'Clear visual reminders for your court',
  price: '$15'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/xtkhgrXg5HWr7mtd3Uomkc/_Bad_3.webp',
  title: 'Skills Assessment & Progress Tracker Bundle',
  description: 'Show students how far they have come',
  price: '$17'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/wArELLcihJbqN446VJ4wMJ/Bad_4.webp',
  title: 'No-Prep Emergency Sub Plans',
  description: 'Keep the lesson moving, even on short notice',
  price: '$21'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/8ZSkwEDarwLMkSdDX2UxVT/Bad_5.webp',
  title: 'Home Practice & Family Challenge Cards',
  description: 'Extend skills beyond the school day',
  price: '$13'
}];
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-17" data-mp="2lm3sxkb64ie">
      <Reveal className="mx-auto max-w-3xl" data-id="element-18" data-mp="2k19n91wonl2">
        <div className="mb-12 text-center" data-id="element-19" data-mp="7kp6wcgqa0nq">
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-20" data-mp="7li7evp3ftxf">🎁 5 Exclusive Bonuses</h2>
          <p className="mt-4 text-brand-gray" data-id="element-21" data-mp="cj0kmya58vb8">Worth <span className="font-bold text-brand-purple line-through" data-id="element-22" data-mp="chz4wgi6nkn6">$85 USD</span> — <strong className="text-brand-teal" data-id="element-23" data-mp="gjkik42jk2yf">yours FREE when you order today.</strong></p>
        </div>
        <div className="space-y-3" data-id="element-24" data-mp="le6ty78mhvii">
          {bonuses.map(({
          image,
          title,
          description,
          price
        }, index) => <article key={title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-25" data-mp="qd18uy3gyzxc" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-serif font-bold text-white" data-id="element-26" data-mp="10afq2zx7vsqp">{index + 1}</span>
              <img src={image} alt={`Cover of ${title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-27" data-mp="5m5v8fpwpnoa" />
              <div className="min-w-0 flex-1" data-id="element-28" data-mp="kcd5471ulydd">
                <h3 className="font-bold leading-snug text-brand-blue" data-id="element-29" data-mp="fjsdnc6ezxd0">{title}</h3>
                <p className="mt-1 text-xs" data-id="element-30" data-mp="tbgkp11t3vn4"><span className="text-brand-gray" data-id="element-31" data-mp="tap16olhhod7">{description}</span><span className="ml-2 font-semibold text-brand-purple line-through" data-id="element-32" data-mp="tdjn6kk5bh8q">was {price}</span><span className="ml-2 font-extrabold text-brand-teal" data-id="element-33" data-mp="oeq6kj9kba4c">FREE</span></p>
              </div>
            </article>)}
        </div>
        <div className="mt-10 text-center" data-id="element-34" data-mp="yajror1ckbxq"><CTAButton data-id="element-35" data-mp="ybcph2ibvr3q">GET THE BADMINTON READY PACK</CTAButton></div>
      </Reveal>
    </section>;
}